var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42.667v32H0V0z",
    fill: "#00006A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.266 20.29h4.362L4.82.01 0 0z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.034 20.288L3.214 0l-1.62.025L22.5 20.29h1.534z",
    fill: "#F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.628 0L4.362 20.29H0L20.807.01l4.82-.01z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.03 0L3.217 20.288h-1.62L22.497 0h1.533z",
    fill: "#F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.764 0h4.1v20.29h-4.1V0z",
    fill: "#FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.116h25.627v4.058H0V8.116z",
    fill: "#FFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.66 0h2.307v20.29H11.66V0z",
    fill: "#F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.13h25.627v2.03H0V9.13z",
    fill: "#F00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.667 11.955l-1.305-.965-1.353.895.51-1.546-1.266-1.018 1.62.01.57-1.525.493 1.55 1.617.077-1.315.95z",
    fill: "#FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.144 11.174l-.772-.558-.79.534.29-.91-.748-.59.952-.005.326-.898.298.908.95.034-.766.565z",
    fill: "#F00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.66 20.27l-1.306-.965L27 20.2l.51-1.546-1.265-1.017 1.62.01.57-1.525.493 1.55 1.617.077-1.315.95z",
    fill: "#FFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.135 19.49l-.772-.56-.79.535.29-.91-.748-.59.952-.005.326-.898.298.908.95.034-.765.566z",
    fill: "#F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.91 19.45l-1.306-.965-1.353.895.51-1.546-1.264-1.017 1.62.01.57-1.525.493 1.55 1.616.077-1.315.95z",
    fill: "#FFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.385 18.67l-.772-.56-.79.535.29-.91-.748-.59.952-.005.326-.898.298.908.95.034-.765.566z",
    fill: "#F00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.55 31.278l-1.304-.965-1.353.895.51-1.546-1.265-1.017 1.62.01.57-1.525.493 1.55 1.618.077-1.315.95z",
    fill: "#FFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.027 30.497l-.772-.558-.79.533.29-.91-.748-.59.952-.005.325-.898.298.908.95.034-.766.566z",
    fill: "#F00"
  })));
};
export default SvgNz;